// src/components/Service/ServiceDetail/ServiceDetailsSection.jsx
const ServiceDetailsSection = ({ service }) => {
  if (!service) return null; // fallback nếu không có dữ liệu

  return (
    <section className="service-details-section fix section-padding">
      <div className="container">
        <div className="service-details-wrapper">
          <div className="row g-4">
            {service.topSections.map((section, index) => (
              <div
                className={`col-xl-4 col-lg-4 col-md-6 ${
                  section.extraClass || ""
                }`}
                key={index}
              >
                <div className="details-content">
                  {section.title && <h2>{section.title}</h2>}
                  {section.text && <p>{section.text}</p>}
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-lg-12">
              {service.mainImage && (
                <div className="details-image">
                  <img
                    src={service.mainImage}
                    alt={service.title}
                  />
                </div>
              )}

              <div className="details-content">
                {service.overviewTitle && (
                  <h3 className="mb-3">{service.overviewTitle}</h3>
                )}
                {service.overviewText && <p>{service.overviewText}</p>}

                {service.listItems && service.listItems.length > 0 && (
                  <div className="details-list-items">
                    {service.listItems.map((list, idx) => (
                      <ul key={idx}>
                        {list.map((item, i) => (
                          <li key={i}>+ {item}</li>
                        ))}
                      </ul>
                    ))}
                  </div>
                )}

                {service.keyFeaturesTitle && (
                  <h3 className="mb-3">{service.keyFeaturesTitle}</h3>
                )}
                {service.keyFeaturesText && <p>{service.keyFeaturesText}</p>}
              </div>

              {service.secondaryImages &&
                service.secondaryImages.length > 0 && (
                  <div className="details-image-2">
                    <div className="row">
                      {service.secondaryImages.map((img, idx) => (
                        <div
                          className={`col-lg-${img.col || 6}`}
                          key={idx}
                        >
                          <img
                            src={img.src}
                            alt={img.alt || `Detail ${idx + 1}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              {service.additionalText &&
                service.additionalText.map((p, idx) => (
                  <p
                    key={idx}
                    className={p.className || ""}
                  >
                    {p.text}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailsSection;
